import { urlPathname, uniqueBy } from "../../utils/unique"
import type ProductModel from "@src/models/product"

export const PDP_THUMB_W = 88
export const PDP_THUMB_H = 88
export const PDP_THUMB_GAP = 28
/** 4 thumbs + 3 gaps — keeps vertical Swiper from collapsing to ~0 height */
export const PDP_THUMB_STACK_H =
  PDP_THUMB_H * 4 + PDP_THUMB_GAP * 3

function extractImageUrl(item: unknown): string {
  if (!item) return ""
  if (typeof item === "string") return item
  if (typeof item === "object" && item !== null) {
    const obj = item as Record<string, any>
    if (typeof obj.large?.url === "string") return obj.large.url
    if (typeof obj.url === "string") return obj.url
    if (typeof obj.small?.url === "string") return obj.small.url
  }
  return ""
}

/** Product gallery URLs, excluding size-chart assets and preferring color swatch photos. */
export function getProductGalleryImages(detail?: ProductModel | null): string[] {
  if (!detail) return []

  const sizePaths = new Set(
    [detail.size_image, ...(detail.size_images || [])]
      .filter(Boolean)
      .map(url => urlPathname(url))
  )

  const productImages = ((detail.images || []) as unknown[])
    .map(extractImageUrl)
    .filter(Boolean)
    .filter(image => !sizePaths.has(urlPathname(image)))

  const attributeImages = (detail.attributes || [])
    .map(attribute => extractImageUrl(attribute?.image))
    .filter(Boolean)
    .filter(image => !sizePaths.has(urlPathname(image)))

  const images = uniqueBy([...productImages, ...attributeImages], urlPathname)

  if (detail.video) {
    images.unshift(detail.video)
  }

  return images
}

export function getProductVideo(detail?: ProductModel | null): string | undefined {
  return detail?.video
}
